// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   Alert,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   Fab,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   TableSortLabel,
//   TableContainer,
//   Stepper,
//   Step,
//   StepLabel,
//   Divider,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Close as CloseIcon,
//   Pets as CalvingIcon,
//   FilterList as FilterIcon,
//   Search as SearchIcon,
//   Agriculture as AgricultureIcon,
//   CalendarToday as DateIcon,
//   // Cow as CalvingIcon,
//   Assignment as OutcomeIcon,
//   Numbers as CalfIcon,
//   Warning as ComplicationsIcon,
// } from "@mui/icons-material";
// import { TableVirtuoso } from "react-virtuoso";
// import { useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Virtualized Table Components
// const VirtuosoTableComponents = {
//   Scroller: React.forwardRef((props, ref) => (
//     <TableContainer component={Paper} {...props} ref={ref} />
//   )),
//   Table: (props) => (
//     <Table
//       {...props}
//       sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
//     />
//   ),
//   TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
//   TableRow: (props) => <TableRow {...props} />,
//   TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
// };

// const CalvingEventsPage = () => {
//   const navigate = useNavigate();
//   const [calvingEvents, setCalvingEvents] = useState([]);
//   const [filteredEvents, setFilteredEvents] = useState([]);
//   const [loading, setLoading] = useState(false);
  
//   // Filters and Search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [filters, setFilters] = useState({
//     outcome: "",
//     animal_id: ""
//   });

//   // Dialogs
//   const [showFilters, setShowFilters] = useState(false);
//   const [openCreateDialog, setOpenCreateDialog] = useState(false);
//   const [openEditDialog, setOpenEditDialog] = useState(false);
//   const [openViewDialog, setOpenViewDialog] = useState(false);
//   const [selectedEvent, setSelectedEvent] = useState(null);

//   // Form Data
//   const [calvingForm, setCalvingForm] = useState({
//     animal_id: "",
//     date: new Date().toISOString().split('T')[0],
//     outcome: "",
//     calf_ids: "",
//     complications: ""
//   });

//   const [animals, setAnimals] = useState([]);

//   const API_URL = "https://dairy.server.statify.co.ke/api/calving-events";

//   // Table Columns for Virtualized Table
//   const columns = [
//     { width: 120, label: 'Animal ID', dataKey: 'animal_id' },
//     { width: 150, label: 'Animal Name', dataKey: 'animal_name' },
//     { width: 120, label: 'Calving Date', dataKey: 'date' },
//     { width: 120, label: 'Outcome', dataKey: 'outcome' },
//     { width: 150, label: 'Calf IDs', dataKey: 'calf_ids' },
//     { width: 150, label: 'Complications', dataKey: 'complications' },
//     { width: 120, label: 'Status', dataKey: 'status' },
//     { width: 200, label: 'Actions', dataKey: 'actions' },
//   ];

//   // Outcome Options
//   const outcomeOptions = ["live", "stillborn", "abortion"];

//   // Helper function to format date for form input
//   const formatDateForInput = (dateString) => {
//     if (!dateString) return new Date().toISOString().split('T')[0];
    
//     try {
//       const date = new Date(dateString);
      
//       if (isNaN(date.getTime())) {
//         console.warn('Invalid date:', dateString);
//         return new Date().toISOString().split('T')[0];
//       }
      
//       return date.toISOString().split('T')[0];
//     } catch (error) {
//       console.error('Error formatting date:', error, dateString);
//       return new Date().toISOString().split('T')[0];
//     }
//   };

//   // Fetch only cows (animals with animal_class = 'Cow')
//   const fetchCows = async () => {
//     try {
//       const res = await fetch("https://dairy.server.statify.co.ke/api/animals");
//       const data = await res.json();
      
//       let animalsList = [];
      
//       if (data.animals && Array.isArray(data.animals)) {
//         animalsList = data.animals;
//       } else if (Array.isArray(data)) {
//         animalsList = data;
//       } else if (data.data && Array.isArray(data.data)) {
//         animalsList = data.data;
//       }
      
//       // Filter only cows (animals with animal_class = 'Cow')
//       const cowsOnly = animalsList.filter(animal => 
//         animal.animal_class === 'Cow' || 
//         animal.animal_class === 'cow' ||
//         (animal.species === 'Cattle' && animal.sex === 'Female')
//       );
      
//       console.log('Filtered cows:', cowsOnly);
//       setAnimals(cowsOnly);
//     } catch (err) {
//       console.error('Error fetching cows:', err);
//       swal("Error", "Failed to fetch cows", "error");
//     }
//   };

//   // Fetch Calving Events
//   const fetchCalvingEvents = async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(API_URL);
//       const data = await res.json();
      
//       if (Array.isArray(data)) {
//         // Transform data to include animal names and status
//         const transformedEvents = await Promise.all(
//           data.map(async (event) => {
//             let animalName = "Unknown";
//             let animalTag = "Unknown";
//             try {
//               // Fetch animal details to get the name
//               const animalRes = await fetch(`https://dairy.server.statify.co.ke/api/animals/${event.animal_id}`);
//               if (animalRes.ok) {
//                 const animalData = await animalRes.json();
//                 animalName = animalData.name || `Animal ${event.animal_id}`;
//                 animalTag = animalData.tag_number || `Tag ${event.animal_id}`;
//               }
//             } catch (err) {
//               console.error('Error fetching animal details:', err);
//             }

//             // Format date for display
//             let displayDate = "Invalid Date";
//             try {
//               const date = new Date(event.date);
//               if (!isNaN(date.getTime())) {
//                 displayDate = date.toLocaleDateString();
//               }
//             } catch (err) {
//               console.error('Error formatting display date:', err);
//             }

//             return {
//               ...event,
//               animal_name: animalName,
//               animal_tag: animalTag,
//               status: event.outcome === "live" ? "Successful" : 
//                      event.outcome === "stillborn" ? "Stillborn" : "Abortion",
//               date: displayDate,
//               originalDate: event.date // Keep original date for editing
//             };
//           })
//         );
//         setCalvingEvents(transformedEvents);
//       } else {
//         setCalvingEvents([]);
//       }
//     } catch (err) {
//       console.error('Error fetching calving events:', err);
//       swal("Error", "Failed to fetch calving events", "error");
//       setCalvingEvents([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCalvingEvents();
//     fetchCows(); // Changed from fetchAnimals to fetchCows
//   }, []);

//   // Filter events based on search and filters
//   useEffect(() => {
//     if (!Array.isArray(calvingEvents)) {
//       setFilteredEvents([]);
//       return;
//     }
    
//     let results = calvingEvents;

//     // Apply search term
//     if (searchTerm) {
//       results = results.filter(event =>
//         (event.animal_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (event.animal_tag?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (event.calf_ids?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (event.outcome?.toLowerCase() || '').includes(searchTerm.toLowerCase())
//       );
//     }

//     // Apply outcome filter
//     if (filters.outcome) {
//       results = results.filter(event => 
//         event.outcome === filters.outcome
//       );
//     }

//     // Apply animal filter
//     if (filters.animal_id) {
//       results = results.filter(event => 
//         event.animal_id.toString() === filters.animal_id
//       );
//     }

//     // Apply sorting
//     if (sortConfig.key) {
//       results.sort((a, b) => {
//         const aVal = a[sortConfig.key];
//         const bVal = b[sortConfig.key];
        
//         if (aVal === null || aVal === undefined) return 1;
//         if (bVal === null || bVal === undefined) return -1;
        
//         if (typeof aVal === 'string' && typeof bVal === 'string') {
//           return sortConfig.direction === 'asc' 
//             ? aVal.localeCompare(bVal)
//             : bVal.localeCompare(aVal);
//         }
        
//         if (aVal < bVal) {
//           return sortConfig.direction === 'asc' ? -1 : 1;
//         }
//         if (aVal > bVal) {
//           return sortConfig.direction === 'asc' ? 1 : -1;
//         }
//         return 0;
//       });
//     }

//     setFilteredEvents(results);
//   }, [calvingEvents, searchTerm, filters, sortConfig]);

//   // Sort Handler
//   const handleSort = (key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Filter Handlers
//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   };

//   const resetFilters = () => {
//     setFilters({
//       outcome: "",
//       animal_id: ""
//     });
//     setSearchTerm("");
//     setSortConfig({ key: null, direction: 'asc' });
//   };

//   // Form Handlers
//   const handleFormChange = (field, value) => {
//     setCalvingForm(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   const resetForm = () => {
//     setCalvingForm({
//       animal_id: "",
//       date: new Date().toISOString().split('T')[0],
//       outcome: "",
//       calf_ids: "",
//       complications: ""
//     });
//   };

//   // Create Calving Event
//   const handleCreateCalvingEvent = async () => {
//     // Validation
//     if (!calvingForm.animal_id || !calvingForm.outcome) {
//       swal("Error", "Animal and outcome are required", "error");
//       return;
//     }

//     try {
//       const res = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...calvingForm,
//           animal_id: parseInt(calvingForm.animal_id)
//         }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Calving event recorded successfully!", "success");
//         setOpenCreateDialog(false);
//         resetForm();
//         fetchCalvingEvents();
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Update Calving Event
//   const handleUpdateCalvingEvent = async () => {
//     if (!selectedEvent) return;

//     try {
//       const res = await fetch(`${API_URL}/${selectedEvent.id}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...calvingForm,
//           animal_id: parseInt(calvingForm.animal_id)
//         }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Calving event updated successfully!", "success");
//         setOpenEditDialog(false);
//         setSelectedEvent(null);
//         resetForm();
//         fetchCalvingEvents();
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Delete Handler
//   const handleDelete = async (eventId) => {
//     const confirm = await swal({
//       title: "Are you sure?",
//       text: "This will permanently delete the calving event!",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${eventId}`, { method: "DELETE" });
//         const data = await res.json();
//         if (res.ok) {
//           swal("Deleted!", data.message, "success");
//           fetchCalvingEvents();
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       }
//     }
//   };

//   // View Handler
//   const handleView = (event) => {
//     setSelectedEvent(event);
//     setOpenViewDialog(true);
//   };

//   // Open Edit Dialog - FIXED VERSION
//   const handleEdit = (event) => {
//     setSelectedEvent(event);
    
//     // Use the helper function to safely format the date
//     const formattedDate = formatDateForInput(event.originalDate || event.date);
    
//     setCalvingForm({
//       animal_id: event.animal_id.toString(),
//       date: formattedDate,
//       outcome: event.outcome,
//       calf_ids: event.calf_ids || "",
//       complications: event.complications || ""
//     });
//     setOpenEditDialog(true);
//   };

//   // Get Outcome Color
//   const getOutcomeColor = (outcome) => {
//     switch (outcome) {
//       case "live": return 'success';
//       case "stillborn": return 'error';
//       case "abortion": return 'warning';
//       default: return 'default';
//     }
//   };

//   // Get Outcome Icon
//   const getOutcomeIcon = (outcome) => {
//     switch (outcome) {
//       case "live": return "🎉";
//       case "stillborn": return "😔";
//       case "abortion": return "⚠️";
//       default: return "";
//     }
//   };

//   // Virtualized Table Content
//   const fixedHeaderContent = () => (
//     <TableRow>
//       {columns.map((column) => (
//         <TableCell
//           key={column.dataKey}
//           variant="head"
//           align="left"
//           style={{ width: column.width }}
//           sx={{ 
//             backgroundColor: 'info.main', 
//             color: 'white',
//             fontWeight: 'bold',
//             fontSize: '14px',
//             padding: '12px 8px'
//           }}
//         >
//           <TableSortLabel
//             active={sortConfig.key === column.dataKey}
//             direction={sortConfig.direction}
//             onClick={() => handleSort(column.dataKey)}
//             sx={{ color: 'white !important' }}
//           >
//             {column.label}
//           </TableSortLabel>
//         </TableCell>
//       ))}
//     </TableRow>
//   );

//   const rowContent = (index, event) => (
//     <React.Fragment>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {event.animal_id}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box>
//           <Typography variant="body2" fontWeight="bold" noWrap>
//             {event.animal_name}
//           </Typography>
//           <Typography variant="caption" color="textSecondary" noWrap>
//             Tag: {event.animal_tag}
//           </Typography>
//         </Box>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {event.date}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={`${getOutcomeIcon(event.outcome)} ${event.outcome}`} 
//           size="small"
//           color={getOutcomeColor(event.outcome)}
//           sx={{ fontSize: '0.7rem', height: '24px' }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {event.calf_ids || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap title={event.complications}>
//           {event.complications ? 
//             (event.complications.length > 20 ? 
//               `${event.complications.substring(0, 20)}...` : event.complications) 
//             : 'None'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={event.status} 
//           size="small"
//           color={getOutcomeColor(event.outcome)}
//           sx={{ fontSize: '0.7rem', height: '24px' }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
//           <IconButton 
//             size="small" 
//             color="info"
//             onClick={() => handleView(event)}
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               backgroundColor: 'rgba(2, 136, 209, 0.1)',
//               color: 'info.main',
//               border: '1px solid',
//               borderColor: 'info.light',
//               '&:hover': { 
//                 backgroundColor: 'info.main',
//                 color: 'white'
//               }
//             }}
//           >
//             <ViewIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="primary"
//             onClick={() => handleEdit(event)}
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               backgroundColor: 'rgba(25, 118, 210, 0.1)',
//               color: 'primary.main',
//               border: '1px solid',
//               borderColor: 'primary.light',
//               '&:hover': { 
//                 backgroundColor: 'primary.main',
//                 color: 'white'
//               }
//             }}
//           >
//             <EditIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="error"
//             onClick={() => handleDelete(event.id)}
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               backgroundColor: 'rgba(211, 47, 47, 0.1)',
//               color: 'error.main',
//               border: '1px solid',
//               borderColor: 'error.light',
//               '&:hover': { 
//                 backgroundColor: 'error.main',
//                 color: 'white'
//               }
//             }}
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       </TableCell>
//     </React.Fragment>
//   );

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: 'info.dark' }}>
//         <Toolbar>
//           <CalvingIcon sx={{ mr: 2, fontSize: 32 }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
//             Calving Events
//           </Typography>
//           <Chip 
//             label={`${calvingEvents.length} Events`} 
//             color="secondary" 
//             variant="filled"
//             sx={{ color: 'white', fontWeight: 'bold', mr: 2 }}
//           />
//           <Button 
//             variant="contained" 
//             startIcon={<AddIcon sx={{ fontSize: 24 }} />}
//             onClick={() => setOpenCreateDialog(true)}
//             sx={{ 
//               borderRadius: 2, 
//               backgroundColor: 'success.main',
//               '&:hover': {
//                 backgroundColor: 'success.dark',
//                 transform: 'translateY(-2px)',
//                 boxShadow: 4
//               },
//               transition: 'all 0.3s ease',
//               fontWeight: 'bold',
//               fontSize: '1rem',
//               px: 3,
//               py: 1.5
//             }}
//           >
//             New Calving Event
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: 'info.light' }}>
//           {/* Search and Filters */}
//           <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search by animal name, tag, outcome, calf IDs..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1, fontSize: 24 }} />,
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                   <Button
//                     startIcon={<FilterIcon sx={{ fontSize: 20 }} />}
//                     onClick={() => setShowFilters(!showFilters)}
//                     variant={showFilters ? "contained" : "outlined"}
//                     size="small"
//                     color="info"
//                     sx={{ borderRadius: 2 }}
//                   >
//                     Filters
//                   </Button>
//                   <Button 
//                     onClick={resetFilters} 
//                     variant="outlined" 
//                     size="small" 
//                     color="info"
//                     sx={{ borderRadius: 2 }}
//                   >
//                     Reset
//                   </Button>
//                   <Button 
//                     onClick={fetchCalvingEvents} 
//                     variant="contained" 
//                     size="small" 
//                     color="primary"
//                     startIcon={<AgricultureIcon sx={{ fontSize: 20 }} />}
//                     sx={{ borderRadius: 2 }}
//                   >
//                     Refresh
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Expandable Filters */}
//             {showFilters && (
//               <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Outcome</InputLabel>
//                       <Select
//                         value={filters.outcome}
//                         onChange={(e) => handleFilterChange('outcome', e.target.value)}
//                         label="Outcome"
//                         renderValue={(selected) => {
//                           if (!selected) return "All Outcomes";
//                           return selected.charAt(0).toUpperCase() + selected.slice(1);
//                         }}
//                       >
//                         <MenuItem value="">All Outcomes</MenuItem>
//                         {outcomeOptions.map(outcome => (
//                           <MenuItem key={outcome} value={outcome}>
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                               <span>{getOutcomeIcon(outcome)}</span>
//                               <span>{outcome.charAt(0).toUpperCase() + outcome.slice(1)}</span>
//                             </Box>
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Cow</InputLabel>
//                       <Select
//                         value={filters.animal_id}
//                         onChange={(e) => handleFilterChange('animal_id', e.target.value)}
//                         label="Cow"
//                         renderValue={(selected) => {
//                           if (!selected) return "All Cows";
//                           const selectedAnimal = animals.find(animal => animal.id.toString() === selected);
//                           return selectedAnimal 
//                             ? `${selectedAnimal.name || `Cow ${selectedAnimal.id}`} (${selectedAnimal.tag_number})`
//                             : "All Cows";
//                         }}
//                       >
//                         <MenuItem value="">All Cows</MenuItem>
//                         {animals.map(animal => (
//                           <MenuItem key={animal.id} value={animal.id.toString()}>
//                             <Box>
//                               <Typography variant="body1" fontWeight="bold">
//                                 {animal.name || `Cow ${animal.id}`}
//                               </Typography>
//                               <Typography variant="body2" color="textSecondary">
//                                 Tag: {animal.tag_number} • ID: {animal.id}
//                               </Typography>
//                             </Box>
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </Box>

//           {/* Content Area */}
//           <Box sx={{ p: 2 }}>
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                 <CircularProgress color="info" size={40} />
//               </Box>
//             ) : filteredEvents.length === 0 ? (
//               <Card sx={{ textAlign: 'center', p: 4, border: 2, borderColor: 'info.light' }}>
//                 <CardContent>
//                   <AgricultureIcon sx={{ fontSize: 64, color: 'info.main', mb: 2 }} />
//                   <Typography variant="h5" color="info.main" gutterBottom>
//                     {animals.length === 0 ? "No Cows Available" : "No Calving Events Found"}
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//                     {animals.length === 0 
//                       ? "No cows found in the system. Please add cows first to record calving events."
//                       : "Record your first calving event to track breeding outcomes and calf production"
//                     }
//                   </Typography>
//                   <Button 
//                     variant="contained" 
//                     color="info" 
//                     onClick={() => setOpenCreateDialog(true)} 
//                     size="large"
//                     startIcon={<AddIcon sx={{ fontSize: 24 }} />}
//                     sx={{ borderRadius: 2 }}
//                     disabled={animals.length === 0}
//                   >
//                     {animals.length === 0 ? "Add Cows First" : "Record First Calving"}
//                   </Button>
//                 </CardContent>
//               </Card>
//             ) : (
//               <Paper elevation={0} sx={{ height: 600, border: 1, borderColor: 'info.light', borderRadius: 1 }}>
//                 <TableVirtuoso
//                   data={filteredEvents}
//                   components={VirtuosoTableComponents}
//                   fixedHeaderContent={fixedHeaderContent}
//                   itemContent={rowContent}
//                 />
//               </Paper>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Create Calving Event Dialog */}
//       <Dialog 
//         open={openCreateDialog} 
//         onClose={() => setOpenCreateDialog(false)}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ 
//           sx: { 
//             borderRadius: 3,
//             boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
//           } 
//         }}
//       >
//         <DialogTitle sx={{ 
//           backgroundColor: 'primary.main', 
//           color: 'white',
//           py: 3
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <AddIcon sx={{ mr: 2, fontSize: 32 }} />
//               <Box>
//                 <Typography variant="h5" fontWeight="bold">
//                   Record New Calving Event
//                 </Typography>
//                 <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
//                   Add a new calving event to track breeding outcomes
//                 </Typography>
//               </Box>
//             </Box>
//             <IconButton 
//               onClick={() => setOpenCreateDialog(false)} 
//               sx={{ 
//                 color: 'white',
//                 backgroundColor: 'rgba(255,255,255,0.2)',
//                 '&:hover': {
//                   backgroundColor: 'rgba(255,255,255,0.3)'
//                 }
//               }}
//             >
//               <CloseIcon sx={{ fontSize: 24 }} />
//             </IconButton>
//           </Box>
//         </DialogTitle>
        
//         <DialogContent sx={{ p: 0 }}>
//           {/* Stepper Indicator */}
//           <Box sx={{ px: 4, pt: 3, pb: 2 }}>
//             <Stepper activeStep={0} alternativeLabel>
//               <Step>
//                 <StepLabel>Event Details</StepLabel>
//               </Step>
//               <Step>
//                 <StepLabel>Animal Information</StepLabel>
//               </Step>
//               <Step>
//                 <StepLabel>Review & Submit</StepLabel>
//               </Step>
//             </Stepper>
//           </Box>

//           <Divider />

//           <Box sx={{ p: 4 }}>
//             <Grid container spacing={4}>
//               {/* Left Column - Required Fields */}
//               <Grid item xs={12} md={6}>
//                 <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
//                   <CalvingIcon sx={{ mr: 1 }} />
//                   Required Information
//                 </Typography>

//                 <FormControl fullWidth sx={{ mb: 3 }}>
//                   <InputLabel id="animal-label" sx={{ display: 'flex', alignItems: 'center' }}>
//                     <CalvingIcon sx={{ mr: 1, fontSize: 20 }} />
//                     Select Cow *
//                   </InputLabel>
//                   <Select
//                     labelId="animal-label"
//                     value={calvingForm.animal_id}
//                     onChange={(e) => handleFormChange('animal_id', e.target.value)}
//                     label="Select Cow *"
//                     disabled={animals.length === 0}
//                     renderValue={(selected) => {
//                       if (!selected) return "Select a cow";
//                       const selectedAnimal = animals.find(animal => animal.id.toString() === selected);
//                       return selectedAnimal 
//                         ? `${selectedAnimal.name || `Cow ${selectedAnimal.id}`} (Tag: ${selectedAnimal.tag_number})`
//                         : "Select a cow";
//                     }}
//                   >
//                     {animals.map(animal => (
//                       <MenuItem key={animal.id} value={animal.id.toString()}>
//                         <Box sx={{ width: '100%' }}>
//                           <Typography variant="body1" fontWeight="bold">
//                             {animal.name || `Cow ${animal.id}`}
//                           </Typography>
//                           <Typography variant="body2" color="textSecondary">
//                             Tag: {animal.tag_number} • ID: {animal.id}
//                           </Typography>
//                           {animal.breed && (
//                             <Typography variant="caption" color="textSecondary">
//                               Breed: {animal.breed}
//                             </Typography>
//                           )}
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   {animals.length === 0 && (
//                     <Alert severity="warning" sx={{ mt: 1 }}>
//                       No cows available. Please add cows first to record calving events.
//                     </Alert>
//                   )}
//                 </FormControl>

//                 <FormControl fullWidth sx={{ mb: 3 }}>
//                   <InputLabel id="outcome-label">
//                     <OutcomeIcon sx={{ mr: 1, fontSize: 20 }} />
//                     Outcome *
//                   </InputLabel>
//                   <Select
//                     labelId="outcome-label"
//                     value={calvingForm.outcome}
//                     onChange={(e) => handleFormChange('outcome', e.target.value)}
//                     label="Outcome *"
//                     renderValue={(selected) => {
//                       if (!selected) return "Select outcome";
//                       return (
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <span>{getOutcomeIcon(selected)}</span>
//                           <span>{selected.charAt(0).toUpperCase() + selected.slice(1)}</span>
//                         </Box>
//                       );
//                     }}
//                   >
//                     {outcomeOptions.map(outcome => (
//                       <MenuItem key={outcome} value={outcome}>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//                           <span style={{ fontSize: '20px' }}>{getOutcomeIcon(outcome)}</span>
//                           <Box>
//                             <Typography variant="body1" fontWeight="bold">
//                               {outcome.charAt(0).toUpperCase() + outcome.slice(1)}
//                             </Typography>
//                             <Typography variant="caption" color="textSecondary">
//                               {outcome === 'live' ? 'Live birth' : 
//                                outcome === 'stillborn' ? 'Stillborn calf' : 
//                                'Pregnancy loss'}
//                             </Typography>
//                           </Box>
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>

//                 <TextField
//                   fullWidth
//                   label={
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <DateIcon sx={{ mr: 1, fontSize: 20 }} />
//                       Calving Date
//                     </Box>
//                   }
//                   type="date"
//                   value={calvingForm.date}
//                   onChange={(e) => handleFormChange('date', e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   sx={{ mb: 3 }}
//                 />
//               </Grid>

//               {/* Right Column - Optional Fields */}
//               <Grid item xs={12} md={6}>
//                 <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
//                   <CalfIcon sx={{ mr: 1 }} />
//                   Additional Information
//                 </Typography>

//                 <TextField
//                   fullWidth
//                   label={
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <CalfIcon sx={{ mr: 1, fontSize: 20 }} />
//                       Calf IDs
//                     </Box>
//                   }
//                   placeholder="e.g., C001, C002, C003"
//                   value={calvingForm.calf_ids}
//                   onChange={(e) => handleFormChange('calf_ids', e.target.value)}
//                   helperText="Comma-separated calf identification numbers"
//                   sx={{ mb: 3 }}
//                 />

//                 <TextField
//                   fullWidth
//                   multiline
//                   rows={4}
//                   label={
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <ComplicationsIcon sx={{ mr: 1, fontSize: 20 }} />
//                       Complications & Notes
//                     </Box>
//                   }
//                   placeholder="Describe any complications during calving, observations, or additional notes..."
//                   value={calvingForm.complications}
//                   onChange={(e) => handleFormChange('complications', e.target.value)}
//                   helperText="Optional notes about complications or observations"
//                 />
//               </Grid>
//             </Grid>
//           </Box>
//         </DialogContent>
        
//         <DialogActions sx={{ p: 3, borderTop: 1, borderColor: 'divider' }}>
//           <Button 
//             onClick={() => {
//               setOpenCreateDialog(false);
//               resetForm();
//             }} 
//             size="large"
//             sx={{ 
//               minWidth: 120,
//               borderRadius: 2
//             }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleCreateCalvingEvent} 
//             variant="contained" 
//             color="success"
//             size="large"
//             disabled={!calvingForm.animal_id || !calvingForm.outcome || animals.length === 0}
//             sx={{ 
//               minWidth: 150,
//               borderRadius: 2,
//               fontWeight: 'bold'
//             }}
//           >
//             Record Event
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Calving Event Dialog */}
//       <Dialog 
//         open={openEditDialog} 
//         onClose={() => setOpenEditDialog(false)}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ 
//           sx: { 
//             borderRadius: 3,
//             boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
//           } 
//         }}
//       >
//         <DialogTitle sx={{ 
//           backgroundColor: 'primary.main', 
//           color: 'white',
//           py: 3
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <EditIcon sx={{ mr: 2, fontSize: 32 }} />
//               <Box>
//                 <Typography variant="h5" fontWeight="bold">
//                   Edit Calving Event
//                 </Typography>
//                 <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
//                   Update calving event details
//                 </Typography>
//               </Box>
//             </Box>
//             <IconButton 
//               onClick={() => setOpenEditDialog(false)} 
//               sx={{ 
//                 color: 'white',
//                 backgroundColor: 'rgba(255,255,255,0.2)',
//                 '&:hover': {
//                   backgroundColor: 'rgba(255,255,255,0.3)'
//                 }
//               }}
//             >
//               <CloseIcon sx={{ fontSize: 24 }} />
//             </IconButton>
//           </Box>
//         </DialogTitle>
        
//         <DialogContent sx={{ p: 0 }}>
//           <Box sx={{ p: 4 }}>
//             <Grid container spacing={4}>
//               {/* Left Column - Required Fields */}
//               <Grid item xs={12} md={6}>
//                 <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
//                   {/* <CalvingIcon sx={{ mr: 1 }} /> */}
//                   Required Information
//                 </Typography>

//                 <FormControl fullWidth sx={{ mb: 3 }}>
//                   <InputLabel id="edit-animal-label" sx={{ display: 'flex', alignItems: 'center' }}>
//                     {/* <CalvingIcon sx={{ mr: 1, fontSize: 20 }} /> */}
//                     Select Cow *
//                   </InputLabel>
//                   <Select
//                     labelId="edit-animal-label"
//                     value={calvingForm.animal_id}
//                     onChange={(e) => handleFormChange('animal_id', e.target.value)}
//                     label="Select Cow *"
//                     renderValue={(selected) => {
//                       if (!selected) return "Select a cow";
//                       const selectedAnimal = animals.find(animal => animal.id.toString() === selected);
//                       return selectedAnimal 
//                         ? `${selectedAnimal.name || `Cow ${selectedAnimal.id}`} (Tag: ${selectedAnimal.tag_number})`
//                         : "Select a cow";
//                     }}
//                   >
//                     {animals.map(animal => (
//                       <MenuItem key={animal.id} value={animal.id.toString()}>
//                         <Box sx={{ width: '100%' }}>
//                           <Typography variant="body1" fontWeight="bold">
//                             {animal.name || `Cow ${animal.id}`}
//                           </Typography>
//                           <Typography variant="body2" color="textSecondary">
//                             Tag: {animal.tag_number} • ID: {animal.id}
//                           </Typography>
//                           {animal.breed && (
//                             <Typography variant="caption" color="textSecondary">
//                               Breed: {animal.breed}
//                             </Typography>
//                           )}
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>

//                 <FormControl fullWidth sx={{ mb: 3 }}>
//                   <InputLabel id="edit-outcome-label">
//                     <OutcomeIcon sx={{ mr: 1, fontSize: 20 }} />
//                     Outcome *
//                   </InputLabel>
//                   <Select
//                     labelId="edit-outcome-label"
//                     value={calvingForm.outcome}
//                     onChange={(e) => handleFormChange('outcome', e.target.value)}
//                     label="Outcome *"
//                     renderValue={(selected) => {
//                       if (!selected) return "Select outcome";
//                       return (
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <span>{getOutcomeIcon(selected)}</span>
//                           <span>{selected.charAt(0).toUpperCase() + selected.slice(1)}</span>
//                         </Box>
//                       );
//                     }}
//                   >
//                     {outcomeOptions.map(outcome => (
//                       <MenuItem key={outcome} value={outcome}>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//                           <span style={{ fontSize: '20px' }}>{getOutcomeIcon(outcome)}</span>
//                           <Box>
//                             <Typography variant="body1" fontWeight="bold">
//                               {outcome.charAt(0).toUpperCase() + outcome.slice(1)}
//                             </Typography>
//                             <Typography variant="caption" color="textSecondary">
//                               {outcome === 'live' ? 'Live birth' : 
//                                outcome === 'stillborn' ? 'Stillborn calf' : 
//                                'Pregnancy loss'}
//                             </Typography>
//                           </Box>
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>

//                 <TextField
//                   fullWidth
//                   label={
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <DateIcon sx={{ mr: 1, fontSize: 20 }} />
//                       Calving Date
//                     </Box>
//                   }
//                   type="date"
//                   value={calvingForm.date}
//                   onChange={(e) => handleFormChange('date', e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   sx={{ mb: 3 }}
//                 />
//               </Grid>

//               {/* Right Column - Optional Fields */}
//               <Grid item xs={12} md={6}>
//                 <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
//                   <CalfIcon sx={{ mr: 1 }} />
//                   Additional Information
//                 </Typography>

//                 <TextField
//                   fullWidth
//                   label={
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <CalfIcon sx={{ mr: 1, fontSize: 20 }} />
//                       Calf IDs
//                     </Box>
//                   }
//                   placeholder="e.g., C001, C002, C003"
//                   value={calvingForm.calf_ids}
//                   onChange={(e) => handleFormChange('calf_ids', e.target.value)}
//                   helperText="Comma-separated calf identification numbers"
//                   sx={{ mb: 3 }}
//                 />

//                 <TextField
//                   fullWidth
//                   multiline
//                   rows={4}
//                   label={
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <ComplicationsIcon sx={{ mr: 1, fontSize: 20 }} />
//                       Complications & Notes
//                     </Box>
//                   }
//                   placeholder="Describe any complications during calving, observations, or additional notes..."
//                   value={calvingForm.complications}
//                   onChange={(e) => handleFormChange('complications', e.target.value)}
//                   helperText="Optional notes about complications or observations"
//                 />
//               </Grid>
//             </Grid>
//           </Box>
//         </DialogContent>
        
//         <DialogActions sx={{ p: 3, borderTop: 1, borderColor: 'divider' }}>
//           <Button 
//             onClick={() => setOpenEditDialog(false)} 
//             size="large"
//             sx={{ 
//               minWidth: 120,
//               borderRadius: 2
//             }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleUpdateCalvingEvent} 
//             variant="contained" 
//             color="primary"
//             size="large"
//             disabled={!calvingForm.animal_id || !calvingForm.outcome}
//             sx={{ 
//               minWidth: 200,
//               borderRadius: 2,
//               fontWeight: 'bold'
//             }}
//           >
//             Update Event
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* View Calving Event Dialog */}
//       <Dialog 
//         open={openViewDialog} 
//         onClose={() => setOpenViewDialog(false)}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ sx: { borderRadius: 2 } }}
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <ViewIcon sx={{ mr: 1, fontSize: 28, color: 'info.main' }} />
//               <Typography variant="h6">Calving Event Details</Typography>
//             </Box>
//             <IconButton onClick={() => setOpenViewDialog(false)}>
//               <CloseIcon sx={{ fontSize: 24 }} />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {selectedEvent && (
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Animal Information
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Animal ID:</strong> {selectedEvent.animal_id}
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Animal Name:</strong> {selectedEvent.animal_name}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Tag Number:</strong> {selectedEvent.animal_tag}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
              
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Event Details
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Date:</strong> {selectedEvent.date}
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Outcome:</strong> 
//                       <Chip 
//                         label={`${getOutcomeIcon(selectedEvent.outcome)} ${selectedEvent.outcome}`} 
//                         size="small"
//                         color={getOutcomeColor(selectedEvent.outcome)}
//                         sx={{ ml: 1 }}
//                       />
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Calf Information
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Calf IDs:</strong> {selectedEvent.calf_ids || 'N/A'}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Health & Complications
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Complications:</strong> {selectedEvent.complications || 'None reported'}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Add FAB for mobile */}
//       <Fab
//         color="info"
//         aria-label="add"
//         sx={{
//           position: 'fixed',
//           bottom: 24,
//           right: 24,
//           display: { xs: 'flex', md: 'none' }
//         }}
//         onClick={() => setOpenCreateDialog(true)}
//         disabled={animals.length === 0}
//       >
//         <AddIcon />
//       </Fab>
//     </Box>
//   );
// };

// export default CalvingEventsPage;



import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Grid,
  Card,
  CardContent,
  Alert,
  CircularProgress,
  AppBar,
  Toolbar,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  TableContainer,
  Stepper,
  Step,
  StepLabel,
  Divider,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Close as CloseIcon,
  Pets as CalvingIcon,
  FilterList as FilterIcon,
  Search as SearchIcon,
  Agriculture as AgricultureIcon,
  CalendarToday as DateIcon,
  Assignment as OutcomeIcon,
  Numbers as CalfIcon,
  Warning as ComplicationsIcon,
} from "@mui/icons-material";
import { TableVirtuoso } from "react-virtuoso";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

// Virtualized Table Components
const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table
      {...props}
      sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
    />
  ),
  TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
  TableRow: (props) => <TableRow {...props} />,
  TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

const CalvingEventsPage = () => {
  const navigate = useNavigate();
  const [calvingEvents, setCalvingEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Filters and Search
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filters, setFilters] = useState({
    outcome: "",
    animal_id: ""
  });

  // Dialogs
  const [showFilters, setShowFilters] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  // Form Data
  const [calvingForm, setCalvingForm] = useState({
    animal_id: "",
    date: new Date().toISOString().split('T')[0],
    outcome: "",
    calf_ids: "",
    complications: ""
  });

  const [animals, setAnimals] = useState([]);

  // Custom color theme
  const customColors = {
    primary: '#024A59', // Dark teal
    secondary: '#FFA916', // Orange
    lightTeal: '#e6f0f2',
    lightOrange: '#fff5e6'
  };

  const API_URL = "https://dairy.server.statify.co.ke/api/calving-events";

  // Table Columns for Virtualized Table
  const columns = [
    { width: 120, label: 'Animal ID', dataKey: 'animal_id' },
    { width: 150, label: 'Animal Name', dataKey: 'animal_name' },
    { width: 120, label: 'Calving Date', dataKey: 'date' },
    { width: 120, label: 'Outcome', dataKey: 'outcome' },
    { width: 150, label: 'Calf IDs', dataKey: 'calf_ids' },
    { width: 150, label: 'Complications', dataKey: 'complications' },
    { width: 120, label: 'Status', dataKey: 'status' },
    { width: 200, label: 'Actions', dataKey: 'actions' },
  ];

  // Outcome Options
  const outcomeOptions = ["live", "stillborn", "abortion"];

  // Helper function to format date for form input
  const formatDateForInput = (dateString) => {
    if (!dateString) return new Date().toISOString().split('T')[0];
    
    try {
      const date = new Date(dateString);
      
      if (isNaN(date.getTime())) {
        console.warn('Invalid date:', dateString);
        return new Date().toISOString().split('T')[0];
      }
      
      return date.toISOString().split('T')[0];
    } catch (error) {
      console.error('Error formatting date:', error, dateString);
      return new Date().toISOString().split('T')[0];
    }
  };

  // Fetch only cows (animals with animal_class = 'Cow')
  const fetchCows = async () => {
    try {
      const res = await fetch("https://dairy.server.statify.co.ke/api/animals");
      const data = await res.json();
      
      let animalsList = [];
      
      if (data.animals && Array.isArray(data.animals)) {
        animalsList = data.animals;
      } else if (Array.isArray(data)) {
        animalsList = data;
      } else if (data.data && Array.isArray(data.data)) {
        animalsList = data.data;
      }
      
      // Filter only cows (animals with animal_class = 'Cow')
      const cowsOnly = animalsList.filter(animal => 
        animal.animal_class === 'Cow' || 
        animal.animal_class === 'cow' ||
        (animal.species === 'Cattle' && animal.sex === 'Female')
      );
      
      console.log('Filtered cows:', cowsOnly);
      setAnimals(cowsOnly);
    } catch (err) {
      console.error('Error fetching cows:', err);
      swal("Error", "Failed to fetch cows", "error");
    }
  };

  // Fetch Calving Events
  const fetchCalvingEvents = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      
      if (Array.isArray(data)) {
        // Transform data to include animal names and status
        const transformedEvents = await Promise.all(
          data.map(async (event) => {
            let animalName = "Unknown";
            let animalTag = "Unknown";
            try {
              // Fetch animal details to get the name
              const animalRes = await fetch(`https://dairy.server.statify.co.ke/api/animals/${event.animal_id}`);
              if (animalRes.ok) {
                const animalData = await animalRes.json();
                animalName = animalData.name || `Animal ${event.animal_id}`;
                animalTag = animalData.tag_number || `Tag ${event.animal_id}`;
              }
            } catch (err) {
              console.error('Error fetching animal details:', err);
            }

            // Format date for display
            let displayDate = "Invalid Date";
            try {
              const date = new Date(event.date);
              if (!isNaN(date.getTime())) {
                displayDate = date.toLocaleDateString();
              }
            } catch (err) {
              console.error('Error formatting display date:', err);
            }

            return {
              ...event,
              animal_name: animalName,
              animal_tag: animalTag,
              status: event.outcome === "live" ? "Successful" : 
                     event.outcome === "stillborn" ? "Stillborn" : "Abortion",
              date: displayDate,
              originalDate: event.date // Keep original date for editing
            };
          })
        );
        setCalvingEvents(transformedEvents);
      } else {
        setCalvingEvents([]);
      }
    } catch (err) {
      console.error('Error fetching calving events:', err);
      swal("Error", "Failed to fetch calving events", "error");
      setCalvingEvents([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCalvingEvents();
    fetchCows(); // Changed from fetchAnimals to fetchCows
  }, []);

  // Filter events based on search and filters
  useEffect(() => {
    if (!Array.isArray(calvingEvents)) {
      setFilteredEvents([]);
      return;
    }
    
    let results = calvingEvents;

    // Apply search term
    if (searchTerm) {
      results = results.filter(event =>
        (event.animal_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (event.animal_tag?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (event.calf_ids?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (event.outcome?.toLowerCase() || '').includes(searchTerm.toLowerCase())
      );
    }

    // Apply outcome filter
    if (filters.outcome) {
      results = results.filter(event => 
        event.outcome === filters.outcome
      );
    }

    // Apply animal filter
    if (filters.animal_id) {
      results = results.filter(event => 
        event.animal_id.toString() === filters.animal_id
      );
    }

    // Apply sorting
    if (sortConfig.key) {
      results.sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];
        
        if (aVal === null || aVal === undefined) return 1;
        if (bVal === null || bVal === undefined) return -1;
        
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          return sortConfig.direction === 'asc' 
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        }
        
        if (aVal < bVal) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aVal > bVal) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    setFilteredEvents(results);
  }, [calvingEvents, searchTerm, filters, sortConfig]);

  // Sort Handler
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Filter Handlers
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetFilters = () => {
    setFilters({
      outcome: "",
      animal_id: ""
    });
    setSearchTerm("");
    setSortConfig({ key: null, direction: 'asc' });
  };

  // Form Handlers
  const handleFormChange = (field, value) => {
    setCalvingForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const resetForm = () => {
    setCalvingForm({
      animal_id: "",
      date: new Date().toISOString().split('T')[0],
      outcome: "",
      calf_ids: "",
      complications: ""
    });
  };

  // Create Calving Event
  const handleCreateCalvingEvent = async () => {
    // Validation
    if (!calvingForm.animal_id || !calvingForm.outcome) {
      swal("Error", "Animal and outcome are required", "error");
      return;
    }

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...calvingForm,
          animal_id: parseInt(calvingForm.animal_id)
        }),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Calving event recorded successfully!", "success");
        setOpenCreateDialog(false);
        resetForm();
        fetchCalvingEvents();
      } else {
        swal("Error", data.error, "error");
      }
    } catch (err) {
      swal("Error", "Something went wrong", "error");
    }
  };

  // Update Calving Event
  const handleUpdateCalvingEvent = async () => {
    if (!selectedEvent) return;

    try {
      const res = await fetch(`${API_URL}/${selectedEvent.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...calvingForm,
          animal_id: parseInt(calvingForm.animal_id)
        }),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Calving event updated successfully!", "success");
        setOpenEditDialog(false);
        setSelectedEvent(null);
        resetForm();
        fetchCalvingEvents();
      } else {
        swal("Error", data.error, "error");
      }
    } catch (err) {
      swal("Error", "Something went wrong", "error");
    }
  };

  // Delete Handler
  const handleDelete = async (eventId) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "This will permanently delete the calving event!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      try {
        const res = await fetch(`${API_URL}/${eventId}`, { method: "DELETE" });
        const data = await res.json();
        if (res.ok) {
          swal("Deleted!", data.message, "success");
          fetchCalvingEvents();
        } else {
          swal("Error", data.error, "error");
        }
      } catch (err) {
        swal("Error", "Something went wrong", "error");
      }
    }
  };

  // View Handler
  const handleView = (event) => {
    setSelectedEvent(event);
    setOpenViewDialog(true);
  };

  // Open Edit Dialog - FIXED VERSION
  const handleEdit = (event) => {
    setSelectedEvent(event);
    
    // Use the helper function to safely format the date
    const formattedDate = formatDateForInput(event.originalDate || event.date);
    
    setCalvingForm({
      animal_id: event.animal_id.toString(),
      date: formattedDate,
      outcome: event.outcome,
      calf_ids: event.calf_ids || "",
      complications: event.complications || ""
    });
    setOpenEditDialog(true);
  };

  // Get Outcome Color
  const getOutcomeColor = (outcome) => {
    switch (outcome) {
      case "live": return 'success';
      case "stillborn": return 'error';
      case "abortion": return 'warning';
      default: return 'default';
    }
  };

  // Get Outcome Icon
  const getOutcomeIcon = (outcome) => {
    switch (outcome) {
      case "live": return "🎉";
      case "stillborn": return "😔";
      case "abortion": return "⚠️";
      default: return "";
    }
  };

  // Virtualized Table Content
  const fixedHeaderContent = () => (
    <TableRow>
      {columns.map((column) => (
        <TableCell
          key={column.dataKey}
          variant="head"
          align="left"
          style={{ width: column.width }}
          sx={{ 
            backgroundColor: customColors.primary, 
            color: 'white',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '12px 8px'
          }}
        >
          <TableSortLabel
            active={sortConfig.key === column.dataKey}
            direction={sortConfig.direction}
            onClick={() => handleSort(column.dataKey)}
            sx={{ color: 'white !important' }}
          >
            {column.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  );

  const rowContent = (index, event) => (
    <React.Fragment>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" fontWeight="bold" noWrap>
          {event.animal_id}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Box>
          <Typography variant="body2" fontWeight="bold" noWrap>
            {event.animal_name}
          </Typography>
          <Typography variant="caption" color="textSecondary" noWrap>
            Tag: {event.animal_tag}
          </Typography>
        </Box>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {event.date}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={`${getOutcomeIcon(event.outcome)} ${event.outcome}`} 
          size="small"
          color={getOutcomeColor(event.outcome)}
          sx={{ fontSize: '0.7rem', height: '24px' }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {event.calf_ids || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap title={event.complications}>
          {event.complications ? 
            (event.complications.length > 20 ? 
              `${event.complications.substring(0, 20)}...` : event.complications) 
            : 'None'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={event.status} 
          size="small"
          color={getOutcomeColor(event.outcome)}
          sx={{ fontSize: '0.7rem', height: '24px' }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
          <IconButton 
            size="small" 
            onClick={() => handleView(event)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              backgroundColor: customColors.lightTeal,
              color: customColors.primary,
              '&:hover': { 
                backgroundColor: customColors.primary,
                color: 'white'
              }
            }}
          >
            <ViewIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={() => handleEdit(event)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              backgroundColor: customColors.lightOrange,
              color: customColors.secondary,
              '&:hover': { 
                backgroundColor: customColors.secondary,
                color: 'white'
              }
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={() => handleDelete(event.id)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              backgroundColor: 'rgba(211, 47, 47, 0.1)',
              color: 'error.main',
              '&:hover': { 
                backgroundColor: 'error.main',
                color: 'white'
              }
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </TableCell>
    </React.Fragment>
  );

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
      {/* Header */}
      <AppBar position="static" elevation={2} sx={{ backgroundColor: customColors.primary }}>
        <Toolbar>
          <CalvingIcon sx={{ mr: 2, fontSize: 32 }} />
          <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            Calving Events
          </Typography>
          <Chip 
            label={`${calvingEvents.length} Events`} 
            sx={{ 
              backgroundColor: customColors.secondary, 
              color: 'white', 
              fontWeight: 'bold', 
              mr: 2 
            }}
          />
          <Button 
            variant="contained" 
            startIcon={<AddIcon sx={{ fontSize: 24 }} />}
            onClick={() => setOpenCreateDialog(true)}
            sx={{ 
              borderRadius: 2, 
              backgroundColor: customColors.secondary,
              '&:hover': {
                backgroundColor: '#e69900',
                transform: 'translateY(-2px)',
                boxShadow: 4
              },
              transition: 'all 0.3s ease',
              fontWeight: 'bold',
              fontSize: '1rem',
              px: 3,
              py: 1.5
            }}
          >
            New Calving Event
          </Button>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ p: 3 }}>
        <Paper sx={{ 
          mb: 3, 
          borderRadius: 2, 
          border: 2, 
          borderColor: customColors.lightTeal,
          backgroundColor: customColors.lightTeal
        }}>
          {/* Search and Filters */}
          <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  placeholder="Search by animal name, tag, outcome, calf IDs..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'white',
                      '&:hover fieldset': {
                        borderColor: customColors.primary,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: customColors.primary,
                      },
                    }
                  }}
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ color: customColors.primary, mr: 1, fontSize: 24 }} />,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <Button
                    startIcon={<FilterIcon sx={{ fontSize: 20 }} />}
                    onClick={() => setShowFilters(!showFilters)}
                    variant={showFilters ? "contained" : "outlined"}
                    size="small"
                    sx={{
                      backgroundColor: showFilters ? customColors.primary : 'transparent',
                      color: showFilters ? 'white' : customColors.primary,
                      borderColor: customColors.primary,
                      '&:hover': {
                        backgroundColor: showFilters ? '#023a47' : customColors.lightOrange,
                        borderColor: customColors.primary
                      }
                    }}
                  >
                    Filters
                  </Button>
                  <Button 
                    onClick={resetFilters} 
                    variant="outlined" 
                    size="small" 
                    sx={{
                      color: customColors.primary,
                      borderColor: customColors.primary,
                      '&:hover': {
                        backgroundColor: customColors.lightOrange,
                        borderColor: customColors.primary
                      }
                    }}
                  >
                    Reset
                  </Button>
                  <Button 
                    onClick={fetchCalvingEvents} 
                    variant="contained" 
                    size="small" 
                    startIcon={<AgricultureIcon sx={{ fontSize: 20 }} />}
                    sx={{
                      backgroundColor: customColors.primary,
                      '&:hover': {
                        backgroundColor: '#023a47'
                      }
                    }}
                  >
                    Refresh
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {/* Expandable Filters */}
            {showFilters && (
              <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Outcome</InputLabel>
                      <Select
                        value={filters.outcome}
                        onChange={(e) => handleFilterChange('outcome', e.target.value)}
                        label="Outcome"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '&:hover fieldset': {
                              borderColor: customColors.primary,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: customColors.primary,
                            },
                          }
                        }}
                        renderValue={(selected) => {
                          if (!selected) return "All Outcomes";
                          return selected.charAt(0).toUpperCase() + selected.slice(1);
                        }}
                      >
                        <MenuItem value="">All Outcomes</MenuItem>
                        {outcomeOptions.map(outcome => (
                          <MenuItem key={outcome} value={outcome}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <span>{getOutcomeIcon(outcome)}</span>
                              <span>{outcome.charAt(0).toUpperCase() + outcome.slice(1)}</span>
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Cow</InputLabel>
                      <Select
                        value={filters.animal_id}
                        onChange={(e) => handleFilterChange('animal_id', e.target.value)}
                        label="Cow"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '&:hover fieldset': {
                              borderColor: customColors.primary,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: customColors.primary,
                            },
                          }
                        }}
                        renderValue={(selected) => {
                          if (!selected) return "All Cows";
                          const selectedAnimal = animals.find(animal => animal.id.toString() === selected);
                          return selectedAnimal 
                            ? `${selectedAnimal.name || `Cow ${selectedAnimal.id}`} (${selectedAnimal.tag_number})`
                            : "All Cows";
                        }}
                      >
                        <MenuItem value="">All Cows</MenuItem>
                        {animals.map(animal => (
                          <MenuItem key={animal.id} value={animal.id.toString()}>
                            <Box>
                              <Typography variant="body1" fontWeight="bold">
                                {animal.name || `Cow ${animal.id}`}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                Tag: {animal.tag_number} • ID: {animal.id}
                              </Typography>
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>

          {/* Content Area */}
          <Box sx={{ p: 2 }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress sx={{ color: customColors.primary }} size={40} />
              </Box>
            ) : filteredEvents.length === 0 ? (
              <Card sx={{ 
                textAlign: 'center', 
                p: 4, 
                border: 2, 
                borderColor: customColors.lightTeal,
                backgroundColor: 'white'
              }}>
                <CardContent>
                  <AgricultureIcon sx={{ fontSize: 64, color: customColors.primary, mb: 2 }} />
                  <Typography variant="h5" sx={{ color: customColors.primary, mb: 1 }}>
                    {animals.length === 0 ? "No Cows Available" : "No Calving Events Found"}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                    {animals.length === 0 
                      ? "No cows found in the system. Please add cows first to record calving events."
                      : "Record your first calving event to track breeding outcomes and calf production"
                    }
                  </Typography>
                  <Button 
                    variant="contained" 
                    onClick={() => setOpenCreateDialog(true)} 
                    size="large"
                    startIcon={<AddIcon sx={{ fontSize: 24 }} />}
                    sx={{ 
                      borderRadius: 2,
                      backgroundColor: customColors.secondary,
                      '&:hover': {
                        backgroundColor: '#e69900'
                      }
                    }}
                    disabled={animals.length === 0}
                  >
                    {animals.length === 0 ? "Add Cows First" : "Record First Calving"}
                  </Button>
                </CardContent>
              </Card>
            ) : (
              <Paper elevation={0} sx={{ 
                height: 600, 
                border: 1, 
                borderColor: customColors.lightTeal, 
                borderRadius: 1 
              }}>
                <TableVirtuoso
                  data={filteredEvents}
                  components={VirtuosoTableComponents}
                  fixedHeaderContent={fixedHeaderContent}
                  itemContent={rowContent}
                />
              </Paper>
            )}
          </Box>
        </Paper>
      </Box>

      {/* Create Calving Event Dialog */}
      <Dialog 
        open={openCreateDialog} 
        onClose={() => setOpenCreateDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ 
          sx: { 
            borderRadius: 3,
            boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
          } 
        }}
      >
        <DialogTitle sx={{ 
          backgroundColor: customColors.primary, 
          color: 'white',
          py: 3
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <AddIcon sx={{ mr: 2, fontSize: 32 }} />
              <Box>
                <Typography variant="h5" fontWeight="bold">
                  Record New Calving Event
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                  Add a new calving event to track breeding outcomes
                </Typography>
              </Box>
            </Box>
            <IconButton 
              onClick={() => setOpenCreateDialog(false)} 
              sx={{ 
                color: 'white',
                backgroundColor: 'rgba(255,255,255,0.2)',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.3)'
                }
              }}
            >
              <CloseIcon sx={{ fontSize: 24 }} />
            </IconButton>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ p: 0 }}>
          {/* Stepper Indicator */}
          <Box sx={{ px: 4, pt: 3, pb: 2 }}>
            <Stepper activeStep={0} alternativeLabel>
              <Step>
                <StepLabel>Event Details</StepLabel>
              </Step>
              <Step>
                <StepLabel>Animal Information</StepLabel>
              </Step>
              <Step>
                <StepLabel>Review & Submit</StepLabel>
              </Step>
            </Stepper>
          </Box>

          <Divider />

          <Box sx={{ p: 4 }}>
            <Grid container spacing={4}>
              {/* Left Column - Required Fields */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom sx={{ mb: 3, display: 'flex', alignItems: 'center', color: customColors.primary }}>
                  <CalvingIcon sx={{ mr: 1 }} />
                  Required Information
                </Typography>

                <FormControl fullWidth sx={{ mb: 3 }}>
                  <InputLabel id="animal-label" sx={{ display: 'flex', alignItems: 'center' }}>
                    <CalvingIcon sx={{ mr: 1, fontSize: 20 }} />
                    Select Cow *
                  </InputLabel>
                  <Select
                    labelId="animal-label"
                    value={calvingForm.animal_id}
                    onChange={(e) => handleFormChange('animal_id', e.target.value)}
                    label="Select Cow *"
                    disabled={animals.length === 0}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: customColors.primary,
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: customColors.primary,
                        },
                      }
                    }}
                    renderValue={(selected) => {
                      if (!selected) return "Select a cow";
                      const selectedAnimal = animals.find(animal => animal.id.toString() === selected);
                      return selectedAnimal 
                        ? `${selectedAnimal.name || `Cow ${selectedAnimal.id}`} (Tag: ${selectedAnimal.tag_number})`
                        : "Select a cow";
                    }}
                  >
                    {animals.map(animal => (
                      <MenuItem key={animal.id} value={animal.id.toString()}>
                        <Box sx={{ width: '100%' }}>
                          <Typography variant="body1" fontWeight="bold">
                            {animal.name || `Cow ${animal.id}`}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            Tag: {animal.tag_number} • ID: {animal.id}
                          </Typography>
                          {animal.breed && (
                            <Typography variant="caption" color="textSecondary">
                              Breed: {animal.breed}
                            </Typography>
                          )}
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                  {animals.length === 0 && (
                    <Alert severity="warning" sx={{ mt: 1 }}>
                      No cows available. Please add cows first to record calving events.
                    </Alert>
                  )}
                </FormControl>

                <FormControl fullWidth sx={{ mb: 3 }}>
                  <InputLabel id="outcome-label">
                    <OutcomeIcon sx={{ mr: 1, fontSize: 20 }} />
                    Outcome *
                  </InputLabel>
                  <Select
                    labelId="outcome-label"
                    value={calvingForm.outcome}
                    onChange={(e) => handleFormChange('outcome', e.target.value)}
                    label="Outcome *"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: customColors.primary,
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: customColors.primary,
                        },
                      }
                    }}
                    renderValue={(selected) => {
                      if (!selected) return "Select outcome";
                      return (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <span>{getOutcomeIcon(selected)}</span>
                          <span>{selected.charAt(0).toUpperCase() + selected.slice(1)}</span>
                        </Box>
                      );
                    }}
                  >
                    {outcomeOptions.map(outcome => (
                      <MenuItem key={outcome} value={outcome}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                          <span style={{ fontSize: '20px' }}>{getOutcomeIcon(outcome)}</span>
                          <Box>
                            <Typography variant="body1" fontWeight="bold">
                              {outcome.charAt(0).toUpperCase() + outcome.slice(1)}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              {outcome === 'live' ? 'Live birth' : 
                               outcome === 'stillborn' ? 'Stillborn calf' : 
                               'Pregnancy loss'}
                            </Typography>
                          </Box>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <DateIcon sx={{ mr: 1, fontSize: 20 }} />
                      Calving Date
                    </Box>
                  }
                  type="date"
                  value={calvingForm.date}
                  onChange={(e) => handleFormChange('date', e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ 
                    mb: 3,
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': {
                        borderColor: customColors.primary,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: customColors.primary,
                      },
                    }
                  }}
                />
              </Grid>

              {/* Right Column - Optional Fields */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom sx={{ mb: 3, display: 'flex', alignItems: 'center', color: customColors.primary }}>
                  <CalfIcon sx={{ mr: 1 }} />
                  Additional Information
                </Typography>

                <TextField
                  fullWidth
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <CalfIcon sx={{ mr: 1, fontSize: 20 }} />
                      Calf IDs
                    </Box>
                  }
                  placeholder="e.g., C001, C002, C003"
                  value={calvingForm.calf_ids}
                  onChange={(e) => handleFormChange('calf_ids', e.target.value)}
                  helperText="Comma-separated calf identification numbers"
                  sx={{ 
                    mb: 3,
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': {
                        borderColor: customColors.primary,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: customColors.primary,
                      },
                    }
                  }}
                />

                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <ComplicationsIcon sx={{ mr: 1, fontSize: 20 }} />
                      Complications & Notes
                    </Box>
                  }
                  placeholder="Describe any complications during calving, observations, or additional notes..."
                  value={calvingForm.complications}
                  onChange={(e) => handleFormChange('complications', e.target.value)}
                  helperText="Optional notes about complications or observations"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': {
                        borderColor: customColors.primary,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: customColors.primary,
                      },
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ p: 3, borderTop: 1, borderColor: 'divider' }}>
          <Button 
            onClick={() => {
              setOpenCreateDialog(false);
              resetForm();
            }} 
            size="large"
            sx={{ 
              minWidth: 120,
              borderRadius: 2,
              color: customColors.primary
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleCreateCalvingEvent} 
            variant="contained" 
            size="large"
            disabled={!calvingForm.animal_id || !calvingForm.outcome || animals.length === 0}
            sx={{ 
              minWidth: 150,
              borderRadius: 2,
              fontWeight: 'bold',
              backgroundColor: customColors.secondary,
              '&:hover': {
                backgroundColor: '#e69900'
              }
            }}
          >
            Record Event
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Calving Event Dialog */}
      <Dialog 
        open={openEditDialog} 
        onClose={() => setOpenEditDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ 
          sx: { 
            borderRadius: 3,
            boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
          } 
        }}
      >
        <DialogTitle sx={{ 
          backgroundColor: customColors.primary, 
          color: 'white',
          py: 3
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <EditIcon sx={{ mr: 2, fontSize: 32 }} />
              <Box>
                <Typography variant="h5" fontWeight="bold">
                  Edit Calving Event
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                  Update calving event details
                </Typography>
              </Box>
            </Box>
            <IconButton 
              onClick={() => setOpenEditDialog(false)} 
              sx={{ 
                color: 'white',
                backgroundColor: 'rgba(255,255,255,0.2)',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.3)'
                }
              }}
            >
              <CloseIcon sx={{ fontSize: 24 }} />
            </IconButton>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ p: 4 }}>
            <Grid container spacing={4}>
              {/* Left Column - Required Fields */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom sx={{ mb: 3, display: 'flex', alignItems: 'center', color: customColors.primary }}>
                  Required Information
                </Typography>

                <FormControl fullWidth sx={{ mb: 3 }}>
                  <InputLabel id="edit-animal-label" sx={{ display: 'flex', alignItems: 'center' }}>
                    Select Cow *
                  </InputLabel>
                  <Select
                    labelId="edit-animal-label"
                    value={calvingForm.animal_id}
                    onChange={(e) => handleFormChange('animal_id', e.target.value)}
                    label="Select Cow *"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: customColors.primary,
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: customColors.primary,
                        },
                      }
                    }}
                    renderValue={(selected) => {
                      if (!selected) return "Select a cow";
                      const selectedAnimal = animals.find(animal => animal.id.toString() === selected);
                      return selectedAnimal 
                        ? `${selectedAnimal.name || `Cow ${selectedAnimal.id}`} (Tag: ${selectedAnimal.tag_number})`
                        : "Select a cow";
                    }}
                  >
                    {animals.map(animal => (
                      <MenuItem key={animal.id} value={animal.id.toString()}>
                        <Box sx={{ width: '100%' }}>
                          <Typography variant="body1" fontWeight="bold">
                            {animal.name || `Cow ${animal.id}`}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            Tag: {animal.tag_number} • ID: {animal.id}
                          </Typography>
                          {animal.breed && (
                            <Typography variant="caption" color="textSecondary">
                              Breed: {animal.breed}
                            </Typography>
                          )}
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth sx={{ mb: 3 }}>
                  <InputLabel id="edit-outcome-label">
                    <OutcomeIcon sx={{ mr: 1, fontSize: 20 }} />
                    Outcome *
                  </InputLabel>
                  <Select
                    labelId="edit-outcome-label"
                    value={calvingForm.outcome}
                    onChange={(e) => handleFormChange('outcome', e.target.value)}
                    label="Outcome *"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: customColors.primary,
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: customColors.primary,
                        },
                      }
                    }}
                    renderValue={(selected) => {
                      if (!selected) return "Select outcome";
                      return (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <span>{getOutcomeIcon(selected)}</span>
                          <span>{selected.charAt(0).toUpperCase() + selected.slice(1)}</span>
                        </Box>
                      );
                    }}
                  >
                    {outcomeOptions.map(outcome => (
                      <MenuItem key={outcome} value={outcome}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                          <span style={{ fontSize: '20px' }}>{getOutcomeIcon(outcome)}</span>
                          <Box>
                            <Typography variant="body1" fontWeight="bold">
                              {outcome.charAt(0).toUpperCase() + outcome.slice(1)}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              {outcome === 'live' ? 'Live birth' : 
                               outcome === 'stillborn' ? 'Stillborn calf' : 
                               'Pregnancy loss'}
                            </Typography>
                          </Box>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <DateIcon sx={{ mr: 1, fontSize: 20 }} />
                      Calving Date
                    </Box>
                  }
                  type="date"
                  value={calvingForm.date}
                  onChange={(e) => handleFormChange('date', e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ 
                    mb: 3,
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': {
                        borderColor: customColors.primary,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: customColors.primary,
                      },
                    }
                  }}
                />
              </Grid>

              {/* Right Column - Optional Fields */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom sx={{ mb: 3, display: 'flex', alignItems: 'center', color: customColors.primary }}>
                  <CalfIcon sx={{ mr: 1 }} />
                  Additional Information
                </Typography>

                <TextField
                  fullWidth
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <CalfIcon sx={{ mr: 1, fontSize: 20 }} />
                      Calf IDs
                    </Box>
                  }
                  placeholder="e.g., C001, C002, C003"
                  value={calvingForm.calf_ids}
                  onChange={(e) => handleFormChange('calf_ids', e.target.value)}
                  helperText="Comma-separated calf identification numbers"
                  sx={{ 
                    mb: 3,
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': {
                        borderColor: customColors.primary,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: customColors.primary,
                      },
                    }
                  }}
                />

                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <ComplicationsIcon sx={{ mr: 1, fontSize: 20 }} />
                      Complications & Notes
                    </Box>
                  }
                  placeholder="Describe any complications during calving, observations, or additional notes..."
                  value={calvingForm.complications}
                  onChange={(e) => handleFormChange('complications', e.target.value)}
                  helperText="Optional notes about complications or observations"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': {
                        borderColor: customColors.primary,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: customColors.primary,
                      },
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ p: 3, borderTop: 1, borderColor: 'divider' }}>
          <Button 
            onClick={() => setOpenEditDialog(false)} 
            size="large"
            sx={{ 
              minWidth: 120,
              borderRadius: 2,
              color: customColors.primary
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleUpdateCalvingEvent} 
            variant="contained" 
            size="large"
            disabled={!calvingForm.animal_id || !calvingForm.outcome}
            sx={{ 
              minWidth: 200,
              borderRadius: 2,
              fontWeight: 'bold',
              backgroundColor: customColors.primary,
              '&:hover': {
                backgroundColor: '#023a47'
              }
            }}
          >
            Update Event
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Calving Event Dialog */}
      <Dialog 
        open={openViewDialog} 
        onClose={() => setOpenViewDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ backgroundColor: customColors.primary, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ViewIcon sx={{ mr: 1, fontSize: 28 }} />
              <Typography variant="h6">Calving Event Details</Typography>
            </Box>
            <IconButton 
              onClick={() => setOpenViewDialog(false)}
              sx={{ color: 'white' }}
            >
              <CloseIcon sx={{ fontSize: 24 }} />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedEvent && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Card variant="outlined" sx={{ borderColor: customColors.lightTeal }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: customColors.primary }}>
                      Animal Information
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Animal ID:</strong> {selectedEvent.animal_id}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Animal Name:</strong> {selectedEvent.animal_name}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Tag Number:</strong> {selectedEvent.animal_tag}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Card variant="outlined" sx={{ borderColor: customColors.lightTeal }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: customColors.primary }}>
                      Event Details
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Date:</strong> {selectedEvent.date}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Outcome:</strong> 
                      <Chip 
                        label={`${getOutcomeIcon(selectedEvent.outcome)} ${selectedEvent.outcome}`} 
                        size="small"
                        color={getOutcomeColor(selectedEvent.outcome)}
                        sx={{ ml: 1 }}
                      />
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Card variant="outlined" sx={{ borderColor: customColors.lightTeal }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: customColors.primary }}>
                      Calf Information
                    </Typography>
                    <Typography variant="body2">
                      <strong>Calf IDs:</strong> {selectedEvent.calf_ids || 'N/A'}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Card variant="outlined" sx={{ borderColor: customColors.lightTeal }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: customColors.primary }}>
                      Health & Complications
                    </Typography>
                    <Typography variant="body2">
                      <strong>Complications:</strong> {selectedEvent.complications || 'None reported'}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setOpenViewDialog(false)}
            sx={{ color: customColors.primary }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add FAB for mobile */}
      <Fab
        aria-label="add"
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          display: { xs: 'flex', md: 'none' },
          backgroundColor: customColors.secondary,
          color: 'white',
          '&:hover': {
            backgroundColor: '#e69900'
          }
        }}
        onClick={() => setOpenCreateDialog(true)}
        disabled={animals.length === 0}
      >
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default CalvingEventsPage;